import { render, staticRenderFns } from "./sidebarMenu.vue?vue&type=template&id=203f795c&scoped=true"
import script from "./sidebarMenu.vue?vue&type=script&lang=ts"
export * from "./sidebarMenu.vue?vue&type=script&lang=ts"
import style0 from "./sidebarMenu.vue?vue&type=style&index=0&lang=less"
import style1 from "./sidebarMenu.vue?vue&type=style&index=1&id=203f795c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203f795c",
  null
  
)

export default component.exports